import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const fetchExchangeRateFromServer = async () => {
  try {
    const mod = await import('@/server/actions/get-exchange-rate');
    return mod.getExchangeRate();
  } catch (err) {
    throw new Error('Failed to fetch exchange rate from server');
  }
};

interface ExchangeRateState {
  toUsd: number | null;
  toJpy: number | null;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: ExchangeRateState = {
  toUsd: null,
  toJpy: null,
  status: 'idle',
};

export const requestExchangeRate = createAsyncThunk(
  'exchangeRate/fetch',
  async () => {
    return await fetchExchangeRateFromServer();
  },
);

const exchangeRateSlice = createSlice({
  name: 'exchangeRate',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(requestExchangeRate.pending, state => {
        state.status = 'loading';
      })
      .addCase(requestExchangeRate.fulfilled, (state, action) => {
        state.status = 'idle';
        state.toJpy = action.payload.toJpy;
        state.toUsd = action.payload.toUsd;
      })
      .addCase(requestExchangeRate.rejected, state => {
        state.status = 'failed';
      });
  },
});

export default exchangeRateSlice.reducer;
